const AUTH_CHANNEL_NAME = 'auth-sync'
const channel = new BroadcastChannel(AUTH_CHANNEL_NAME)

// Отправка события "logout" другим вкладкам
export const notifyLogout = () => {
  channel.postMessage({ type: 'logout' })
}

// Подписка на события между вкладками
export const initAuthSync = (onLogout: () => void) => {
  channel.onmessage = (event) => {
    const { type } = event.data || {}
    if (type === 'logout') {
      onLogout()
    }
  }
}
